/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Sources_NotesInputs */



/**
* | output |
* | --- |
* | "your notes" |
*
* @param {Meeting_Report_Sources_NotesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_sources_notes = /** @type {((inputs?: Meeting_Report_Sources_NotesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Sources_NotesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("jouw notities")
	if (locale === "fr") return /** @type {LocalizedString} */ ("vos notes")
	return /** @type {LocalizedString} */ ("your notes")
});